<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card>
          <v-card-title>
            <v-icon large>mdi-lock-reset</v-icon>
            <h3 v-if="isOAuthUserAndPasswordNotEntered()">{{ $tt('CreatePasswordTitle') }}</h3>
            <h3 v-else>{{ $tt('ChangePasswordTitle') }}</h3>
          </v-card-title>
          <v-form ref="form" v-model="valid" lazy-validation v-if="isOAuthUserAndPasswordNotEntered()">
            <v-card-text>
              <v-text-field
                v-model="newPassword"
                :error-messages="newPasswordErrors"
                type="password"
                :label="$tt('NewPasswordHint')"
                required
                @input="$v.newPassword.$touch()"
                @blur="$v.newPassword.$touch()"
              />
              <v-text-field
                v-model="newPassword2"
                :error-messages="newPassword2Errors"
                type="password"
                :label="$tt('customNewPasswordReInput')"
                required
                @input="$v.newPassword2.$touch()"
                @blur="$v.newPassword2.$touch()"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                type="submit"
                color="primary"
                class="white--text text-none"
                :disabled="!valid"
                @click.stop.prevent="createPassword"
                >{{ $tt('CreatePasswordButton') }}
              </v-btn>
            </v-card-actions>
          </v-form>
          <v-form ref="form" v-model="valid" lazy-validation v-else>
            <v-card-text>
              <v-text-field
                v-model="currentPassword"
                :error-messages="currentPasswordErrors"
                type="password"
                :label="$tt('CurrentPasswordHint')"
                required
                @input="$v.currentPassword.$touch()"
                @blur="$v.currentPassword.$touch()"
                style="margin-bottom: 30px;"
              />
              <v-text-field
                v-model="newPassword"
                :error-messages="newPasswordErrors"
                type="password"
                :label="$tt('NewPasswordHint')"
                required
                @input="$v.newPassword.$touch()"
                @blur="$v.newPassword.$touch()"
              />
              <v-text-field
                v-model="newPassword2"
                :error-messages="newPassword2Errors"
                type="password"
                :label="$tt('customNewPasswordReInput')"
                required
                @input="$v.newPassword2.$touch()"
                @blur="$v.newPassword2.$touch()"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn
                type="submit"
                color="primary"
                class="white--text text-none"
                :disabled="!valid"
                @click.stop.prevent="changePassword"
                >{{ $tt('ChangePasswordButton') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import * as Constants from '@/lib/constants'
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
import UserInfo from '@/lib/user-info'

export default {
  name: 'user-password',
  mixins: [validationMixin],

  validations: {
    currentPassword: {
      required,
      maxLength: maxLength(Constants.PASSWORD_MAX_LENGTH_ON_COGNITO),
    },
    newPassword: {
      required,
      maxLength: maxLength(Constants.PASSWORD_MAX_LENGTH_ON_COGNITO),
      minLength: minLength(Constants.PASSWORD_MIN_LENGTH_ON_COGNITO),
    },
    newPassword2: {
      required,
      maxLength: maxLength(Constants.PASSWORD_MAX_LENGTH_ON_COGNITO),
      minLength: minLength(Constants.PASSWORD_MIN_LENGTH_ON_COGNITO),
      sameAsPassword: sameAs('newPassword'),
    },
  },

  data: () => ({
    currentPassword: null,
    newPassword: null,
    newPassword2: null,
    valid: true,
  }),

  computed: {
    currentPasswordErrors() {
      const errors = []
      if (!this.$v.currentPassword.$dirty) return errors
      !this.$v.currentPassword.required && errors.push(this.$tt('ValidationTextRequired'))
      !this.$v.currentPassword.maxLength && errors.push(this.$tt('customValidationPasswordMaxLength'))
      return errors
    },
    newPasswordErrors() {
      const errors = []
      if (!this.$v.newPassword.$dirty) return errors
      !this.$v.newPassword.required && errors.push(this.$tt('ValidationTextRequired'))
      !this.$v.newPassword.maxLength && errors.push(this.$tt('customValidationPasswordMaxLength'))
      !this.$v.newPassword.minLength &&
        errors.push(this.$tt('customValidationPasswordMinLength', { length: Constants.PASSWORD_MIN_LENGTH_ON_COGNITO }))
      return errors
    },
    newPassword2Errors() {
      const errors = []
      if (!this.$v.newPassword2.$dirty) return errors
      !this.$v.newPassword2.required && errors.push(this.$tt('ValidationTextRequired'))
      !this.$v.newPassword2.maxLength && errors.push(this.$tt('customValidationPasswordMaxLength'))
      !this.$v.newPassword2.minLength &&
        errors.push(this.$tt('customValidationPasswordMinLength', { length: Constants.PASSWORD_MIN_LENGTH_ON_COGNITO }))
      !this.$v.newPassword2.sameAsPassword && errors.push(this.$tt('customValidationPasswordNotMatch'))
      return errors
    },
  },
  mounted() {},
  methods: {
    isOAuthUserAndPasswordNotEntered() {
      if (UserInfo.isOAuthUser()) {
        if (!UserInfo.isPasswordEntered()) {
          return true
        }
      }
      return false
    },
    changePassword() {
      // Do validation
      this.$v.$touch()
      if (this.$v.$error) {
        console.error('Validation Error')
        return
      }
      const changePasswordInfo = { currentPassword: this.currentPassword, newPassword: this.newPassword }
      this.$store.dispatch('authChangePassword', changePasswordInfo)
    },
    createPassword() {
      this.$v.newPassword.$touch()
      this.$v.newPassword2.$touch()
      if (this.$v.$error) {
        console.error('Validation Error')
        return
      }
      const createPasswordInfo = { newPassword: this.newPassword }
      this.$store.dispatch('authCreatePassword', createPasswordInfo)
    },
  },
}
</script>
